var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('Toggle',{attrs:{"state":_vm.state},on:{"toggleItem":_vm.toggleActivity}},[_c('div',{staticClass:"text"},[_vm._v("\n      "+_vm._s(_vm.activity.title)+"\n      "),_c('span',{staticClass:"minor",domProps:{"innerHTML":_vm._s(_vm.streak)}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d2475fa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/activities/ActivityToggle.vue
// module id = null
// module chunks = 